import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, unit, change, changeType, icon, threshold, status }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'critical':
        return 'text-error border-error/20 bg-error/5';
      case 'warning':
        return 'text-warning border-warning/20 bg-warning/5';
      case 'good':
        return 'text-success border-success/20 bg-success/5';
      default:
        return 'text-text-primary border-border bg-card';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-text-secondary';
  };

  return (
    <div className={`p-6 rounded-lg border transition-all duration-200 hover:shadow-elevation-2 ${getStatusColor()}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <h3 className="text-sm font-medium text-text-secondary">{title}</h3>
        </div>
        {threshold && (
          <div className="text-xs text-text-secondary">
            Limit: {threshold}
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <div className="flex items-baseline space-x-2">
          <span className="text-2xl font-bold text-text-primary">{value}</span>
          {unit && <span className="text-sm text-text-secondary">{unit}</span>}
        </div>
        
        {change && (
          <div className="flex items-center space-x-1">
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={14} 
              className={getChangeColor()} 
            />
            <span className={`text-sm font-medium ${getChangeColor()}`}>
              {change}
            </span>
            <span className="text-xs text-text-secondary">vs last period</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;